<template>
  <div class="main-container">
    <div class="game-sorting">
      <div class="game-sorting__left">
        <main-menu></main-menu>
      </div>
      <div class="game-sorting__right">
        <div class="game-sorting-panel">
          <h2 class="main-title">Games Sorting control</h2>

          <div class="btns-row">
            <div class="btns-row__left-btns">
              <div class="loader-wrap">
                <Loader v-if="isLoaderVisible"></Loader>
              </div>
            </div>
          </div>

          <div class="column-control__wrap">
            <div class="column-control__left">
              <SortingList :chosenSortingName="chosenSortingName"
                           v-on:onSelectSorting="onSelectSorting"
                           ref="sortingsList"
              ></SortingList>
            </div>

            <div class="column-control__right">
              <GamesSortingList v-on:onSortingCreated="onSortingCreated"
                                :chosenSortingName="chosenSortingName">
              </GamesSortingList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import SortingList from '../SortingList/SortingList.vue'
  import GamesSortingList from '../GamesSortingList/GamesSortingList.vue'
  import MainMenu from '../../MainMenu/MainMenu.vue'

  export default {
    name: 'FeedsControlMain',
    components: {MainMenu, Loader, SortingList, GamesSortingList},
    data () {
      return {
        isLoaderVisible: false,
        chosenSortingName: null,
        isDeleteModalVisible: false
      }
    },
    methods: {
      // onChooseGames: function (games) {
      //   this.chosenGames = games
      // },
      // onGettingSortings: function (sortings) {
      //   this.sortings = sortings
      // },
      onSelectSorting: function (sortingName) {
        this.chosenSortingName = sortingName
      },
      onSortingCreated: function (sortnigName) {
        Promise.resolve()
          .then(this.$refs.sortingsList.getSortings)
          .then(() => {
            this.chosenSortingName = sortnigName
          })
      }
    }
  }
</script>

<style scoped src="./GamesSortingMain.scss" lang="scss"></style>
